import React, { useState } from "react";
import { CirclePicker } from "react-color";
import DrawingPanel from "./DrawingPannel";
import styled from "styled-components";

export default function Editor() {
  const [panelWidth, setPanelWidth] = useState(16);
  const [panelHeight, setPanelHeight] = useState(16);
  const [hideOptions, setHideOptions] = useState(false);
  const [hideDrawingPanel, setHideDrawingPanel] = useState(true);
  const [buttonText, setButtonText] = useState("start drawing");
  const [selectedColor, setColor] = useState("#f44336");

  function initializeDrawingPanel() {
    setHideOptions(!hideOptions);
    setHideDrawingPanel(!hideDrawingPanel);

    buttonText === "start drawing"
      ? setButtonText("reset")
      : setButtonText("start drawing");
  }

  function changeColor(color) {
    setColor(color.hex);
  }

  const StyledEditor = styled.div`
    border: var(--border-width-hard) solid
      ${({ theme }) => theme.colors.dborder};
    background-color: ${({ theme }) => theme.colors.btncolor};
    border-radius: 0.25rem;
    padding: 1rem 4rem 2rem 4rem;
    margin-top: 2rem;

    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      margin-bottom: 1.5rem;
    }

    h2 {
      margin-bottom: 1rem;
    }

    .button {
      ${({ theme }) => theme.mixins.components.button};
      margin: 1em;
    }

    .circle-picker {
      margin-bottom: 1.5rem !important;
    }
  `;

  const StyledOptions = styled.div`
    display: flex;
    margin-bottom: 3rem;
    justify-content: center;
    gap: 1em;

    .option {
      display: flex;
      flex-direction: column;
    }

    .panelInput {
      height: 5rem;
      width: 5rem;
      font-size: 2rem;
      text-align: center;
      background-color: ${({ theme }) => theme.colors.background};
      /* border: none; */
      border: var(--border-width-hard) solid
        ${({ theme }) => theme.colors.dborder};
      color: ${({ theme }) => theme.colors.primary};
    }
    color: ${({ theme }) => theme.colors.primary};
    /* border: 1px solid ${({ theme }) => theme.colors.dborder}; */
    border-radius: 0.25rem;
    margin: 0 1rem 0.5rem 1rem;
    padding-left: 1rem;

    &:focus {
      outline: none !important;
      border-color: ${({ theme }) => theme.colors.dborder};
      box-shadow: none;
    }
  `;

  return (
    <StyledEditor>
      <h1>Pixel Editor</h1>
      {hideDrawingPanel && <h2>Enter Panel Dimensions</h2>}
      {hideDrawingPanel && (
        <StyledOptions>
          <div className="option">
            <input
              type="number"
              className="panelInput"
              defaultValue={panelWidth}
              onChange={(e) => {
                setPanelWidth(e.target.value);
              }}
            />
            <span>Width</span>
          </div>
          <div className="option">
            <input
              type="number"
              className="panelInput"
              defaultValue={panelHeight}
              onChange={(e) => {
                setPanelHeight(e.target.value);
              }}
            />
            <span>Height</span>
          </div>
        </StyledOptions>
      )}

      <button onClick={initializeDrawingPanel} className="button">
        {buttonText}
      </button>

      {hideOptions && (
        <CirclePicker color={selectedColor} onChangeComplete={changeColor} />
      )}

      {hideOptions && (
        <DrawingPanel
          width={panelWidth}
          height={panelHeight}
          selectedColor={selectedColor}
        />
      )}
    </StyledEditor>
  );
}
